// import React, { useMemo, useState } from 'react';
// import {
//   Typography,
//   Card,
//   CardContent,
//   Box,
//   Stack,
//   Paper,
// } from '@mui/material';
// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   TooltipProps,
//   Cell,
// } from 'recharts';
// import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// // --- Data structure for two separate bars ---
// const chartData = [
//   { name: 'Open AI', time: 18 },
//   { name: 'Gemini', time: 33 },
// ];

// const colors = ['#0064FF', '#FFA600'];

// const legendItems = [
//     { name: 'Open AI', color: '#0064FF' },
//     { name: 'Gemini', color: '#FFA600' },
// ];

// interface CustomTooltipContentProps extends TooltipProps<ValueType, NameType> {
//   activeBarName: string | null;
// }

// const CustomTooltip = ({ active, payload, activeBarName }: CustomTooltipContentProps) => {
//     const currentBarName = payload && payload.length ? (payload[0].payload as any).name : null;
    
//     if (active && payload && payload.length && activeBarName === currentBarName) {
//         const data = payload[0];
//         const name = (data.payload as any).name;
        
//         // --- FIX: Look up the color manually to ensure it's always correct ---
//         const legendItem = legendItems.find(item => item.name === name);
//         const color = legendItem ? legendItem.color : '#ccc'; // Provide a fallback color

//         return (
//             <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter', pointerEvents: 'none' }}>
//                 <Stack spacing={1}>
//                     <Stack direction="row" justifyContent="space-between" alignItems="center">
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <FiberManualRecordIcon sx={{ color: color, fontSize: '10px', mr: 0.75 }} />
//                             <Typography sx={{ fontSize: '12px', fontWeight: 400, color:'#666666' }}>{name}</Typography>
//                         </Box>
//                         <Typography sx={{ fontSize: '12px', fontWeight: 500,  color:'#333333' }}>
//                             {`${Number(data.value || 0).toFixed(0)} sec`}
//                         </Typography>
//                     </Stack>
//                 </Stack>
//             </Card>
//         );
//     }
//     return null;
// };

// // --- Custom Y-Axis Tick Formatter ---
// const CustomYAxisTick = (props: any) => {
//     const { x, y, payload } = props;
//     if (payload.value === 0) {
//         return (
//              <g transform={`translate(${x},${y})`}>
//                 <text x={-10} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>
//                     0ms
//                 </text>
//             </g>
//         );
//     }
//     return (
//       <g transform={`translate(${x},${y})`}>
//         <text x={-10} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>
//           {`${payload.value}s`}
//         </text>
//       </g>
//     );
// };

// const RequestTimeChart: React.FC = () => {
//     const [activeBarName, setActiveBarName] = useState<string | null>(null);

//     const { yAxisDomain, yAxisTicks } = useMemo(() => {
//         const maxTime = Math.max(...chartData.map(item => item.time), 0);
//         const yAxisTopValue = maxTime > 0 ? maxTime * 1.2 : 40;
//         const niceCeiling = Math.ceil(yAxisTopValue / 10) * 10;
//         const ticks = [0, niceCeiling * 0.25, niceCeiling * 0.5, niceCeiling * 0.75, niceCeiling];
//         const finalYAxisMax = ticks[ticks.length - 1] || 40;
//         const domain = [0, finalYAxisMax];
//         return { yAxisDomain: domain, yAxisTicks: ticks };
//     }, []);

//     return (
//         <Card elevation={0} sx={{ borderRadius: '16px', height: '100%', fontFamily: 'Inter, sans-serif' }}>
//             <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//                     <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
//                         Average Request Completion Time
//                     </Typography>
//                     <Stack direction="row" spacing={2} alignItems="center">
//                         {legendItems.map((item) => (
//                             <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                                 <Typography variant="caption" color="text.secondary">
//                                     {item.name}
//                                 </Typography>
//                             </Box>
//                         ))}
//                     </Stack>
//                 </Box>

//                 <Box sx={{ flexGrow: 1, width: '100%' }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart
//                             data={chartData}
//                             margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
//                         >
//                             <CartesianGrid strokeDasharray="4 4" stroke="#EEE" horizontal={true} vertical={false} />
//                             <XAxis dataKey="name" hide={true} />
//                             <YAxis
//                                 axisLine={false}
//                                 tickLine={false}
//                                 domain={yAxisDomain}
//                                 ticks={yAxisTicks}
//                                 tick={<CustomYAxisTick />}
//                             />
//                             <Tooltip
//                                 cursor={false}
//                                 content={<CustomTooltip activeBarName={activeBarName} />}
//                                 isAnimationActive={false}
//                             />
//                             <Bar 
//                                 barSize={6}
//                                 radius={[10, 10, 0, 0]}
//                                 dataKey="time"
//                             >
//                                 {chartData.map((entry, index) => (
//                                     <Cell 
//                                         key={`cell-${index}`} 
//                                         fill={colors[index % colors.length]}
//                                         onMouseEnter={() => setActiveBarName(entry.name)}
//                                         onMouseLeave={() => setActiveBarName(null)}
//                                     />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </Box>
//             </CardContent>
//         </Card>
//     );
// };

// export default RequestTimeChart;



// import React, { useMemo, useState } from 'react';
// import {
//   Typography,
//   Card,
//   CardContent,
//   Box,
//   Stack,
//   Skeleton,
// } from '@mui/material';
// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   TooltipProps,
//   Cell,
// } from 'recharts';
// import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// // --- (Unchanged) Interfaces and Custom Tooltip ---

// interface CustomTooltipContentProps extends TooltipProps<ValueType, NameType> {
//   activeBarName: string | null;
// }

// const colors = {
//     'Open AI': '#0064FF',
//     'Gemini': '#FFA600',
// };

// const legendItems = [
//     { name: 'Open AI', color: colors['Open AI'] },
//     { name: 'Gemini', color: colors['Gemini'] },
// ];

// const CustomTooltip = ({ active, payload, activeBarName }: CustomTooltipContentProps) => {
//     const currentBarName = payload && payload.length ? (payload[0].payload as any).name : null;
    
//     if (active && payload && payload.length && activeBarName === currentBarName) {
//         const data = payload[0];
//         const name = (data.payload as any).name;
//         const color = colors[name as keyof typeof colors] || '#ccc';

//         return (
//             <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter', pointerEvents: 'none' }}>
//                 <Stack spacing={1}>
//                     <Stack direction="row" justifyContent="space-between" alignItems="center">
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                             <FiberManualRecordIcon sx={{ color: color, fontSize: '10px', mr: 0.75 }} />
//                             <Typography sx={{ fontSize: '12px', fontWeight: 400, color:'#666666' }}>{name}</Typography>
//                         </Box>
//                         <Typography sx={{ fontSize: '12px', fontWeight: 500,  color:'#333333' }}>
//                             {`${Number(data.value || 0).toFixed(1)} sec`}
//                         </Typography>
//                     </Stack>
//                 </Stack>
//             </Card>
//         );
//     }
//     return null;
// };

// const CustomYAxisTick = (props: any) => {
//     const { x, y, payload } = props;
//     const value = payload.value;
//     const label = value === 0 ? '0ms' : `${value}s`;
//     return (
//       <g transform={`translate(${x},${y})`}>
//         <text x={-10} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>
//           {label}
//         </text>
//       </g>
//     );
// };

// // --- (New) Interfaces and Helper Functions for Backend Data ---

// // 1. Define the shape of the data point from the backend
// interface PerformanceDataPoint {
//   model: string;
//   avgCompletionTimeSeconds: number;
// }

// // 2. Define the component's props
// interface RequestTimeChartProps {
//   performanceData?: PerformanceDataPoint[];
//   isLoading?: boolean;
// }

// // 3. Helper to group different models for consistent naming
// const getModelGroup = (modelName: string): 'Open AI' | 'Gemini' => {
//   const lowerCaseModel = modelName.toLowerCase();
//   if (lowerCaseModel.includes('gemini')) return 'Gemini';
//   return 'Open AI'; // Default to Open AI
// };


// // --- (Main) Refactored RequestTimeChart Component ---

// const RequestTimeChart: React.FC<RequestTimeChartProps> = ({ performanceData, isLoading }) => {
//     const [activeBarName, setActiveBarName] = useState<string | null>(null);

//     // 4. Transform the backend data into the format required by Recharts
//     const chartData = useMemo(() => {
//         if (!performanceData) return [];
//         return performanceData.map(item => ({
//             name: getModelGroup(item.model),
//             time: item.avgCompletionTimeSeconds
//         }));
//     }, [performanceData]);

//     // 5. Y-axis calculation now uses the transformed data
//     const { yAxisDomain, yAxisTicks } = useMemo(() => {
//         const maxTime = Math.max(...chartData.map(item => item.time), 0);
//         const yAxisTopValue = maxTime > 0 ? maxTime * 1.25 : 10; // Give a bit more headroom
//         const niceCeiling = Math.ceil(yAxisTopValue / 5) * 5; // Round to nearest 5
//         const ticks = [0, niceCeiling * 0.25, niceCeiling * 0.5, niceCeiling * 0.75, niceCeiling];
//         const domain = [0, ticks[ticks.length - 1] || 10];
//         return { yAxisDomain: domain, yAxisTicks: ticks };
//     }, [chartData]);

//     return (
//         <Card elevation={0} sx={{ borderRadius: '16px', height: '100%', fontFamily: 'Inter, sans-serif' }}>
//             <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//                     <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
//                         Average Request Completion Time
//                     </Typography>
//                     <Stack direction="row" spacing={2} alignItems="center">
//                         {legendItems.map((item) => (
//                             <Box key={item.name} sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
//                                 <Typography variant="caption" color="text.secondary">
//                                     {item.name}
//                                 </Typography>
//                             </Box>
//                         ))}
//                     </Stack>
//                 </Box>

//                 <Box sx={{ flexGrow: 1, width: '100%' }}>
//                   {/* 6. Render a skeleton while loading, otherwise render the chart */}
//                   {isLoading ? (
//                     <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }}/>
//                   ) : (
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart
//                             data={chartData}
//                             margin={{ top: 10, right: 10, left: 10, bottom: 0 }}
//                             barCategoryGap="50%" // Add space between the two bars
//                         >
//                             <CartesianGrid strokeDasharray="4 4" stroke="#EEE" horizontal={true} vertical={false} />
//                             <XAxis dataKey="name" hide={true} />
//                             <YAxis
//                                 axisLine={false}
//                                 tickLine={false}
//                                 domain={yAxisDomain}
//                                 ticks={yAxisTicks}
//                                 tick={<CustomYAxisTick />}
//                                 width={40}
//                             />
//                             <Tooltip
//                                 cursor={false}
//                                 content={<CustomTooltip activeBarName={activeBarName} />}
//                                 isAnimationActive={false}
//                             />
//                             <Bar 
//                                 barSize={12} // A slightly wider bar
//                                 radius={[10, 10, 0, 0]}
//                                 dataKey="time"
//                             >
//                                 {chartData.map((entry, index) => (
//                                     <Cell 
//                                         key={`cell-${index}`} 
//                                         // 7. Robustly set color based on name
//                                         fill={colors[entry.name as keyof typeof colors] || '#ccc'}
//                                         onMouseEnter={() => setActiveBarName(entry.name)}
//                                         onMouseLeave={() => setActiveBarName(null)}
//                                     />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                   )}
//                 </Box>
//             </CardContent>
//         </Card>
//     );
// };

// export default RequestTimeChart;


import React, { useMemo, useState } from 'react';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Stack,
  Skeleton,
} from '@mui/material';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  TooltipProps,
  Cell,
} from 'recharts';
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// --- Color Logic ---
// const PREDEFINED_PALETTE = [
//   '#0064FF', '#FBBC05', '#BF83FF', '#3CD856', '#FF947A', '#FA5A7D',
// ];
const PREDEFINED_PALETTE = [
  '#0064FF', '#FFA600', '#FF3023', '#67B341', '#029F8C', '#9B2B11', '#E75D0F', '#AE46BC',
  '#180273','#5B733D', '#6C63C8', '#8C8C8C'
];

const stringToColor = (str: string): string => {
  let hash = 0;
  str.split('').forEach(char => {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  });
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

// --- Interfaces and Custom Components ---
interface CustomTooltipContentProps extends TooltipProps<ValueType, NameType> {
  activeBarName: string | null;
  modelInfo: { [key: string]: { name: string; color: string } };
}

const CustomTooltip = ({ active, payload, activeBarName, modelInfo }: CustomTooltipContentProps) => {
    const currentBarData = payload && payload.length ? payload[0].payload as any : null;
    if (active && currentBarData && activeBarName === currentBarData.name) {
        const { name, time } = currentBarData;
        const color = modelInfo[name]?.color || '#ccc';

        return (
            <Card elevation={3} sx={{ borderRadius: '8px', padding: '12px', minWidth: '180px', fontFamily: 'Inter', pointerEvents: 'none' }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <FiberManualRecordIcon sx={{ color, fontSize: '10px', mr: 0.75 }} />
                        <Typography sx={{ fontSize: '12px', fontWeight: 400, color:'#666666' }}>{name}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: '12px', fontWeight: 500,  color:'#333333' }}>
                        {`${Number(time || 0).toFixed(1)} sec`}
                    </Typography>
                </Stack>
            </Card>
        );
    }
    return null;
};

const CustomYAxisTick = (props: any) => {
    const { x, y, payload } = props;
    const value = payload.value;
    const label = value === 0 ? '0ms' : `${value}s`;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={-10} y={0} dy={4} textAnchor="end" fill="#666" style={{ fontSize: 12, fontFamily: 'Inter' }}>
          {label}
        </text>
      </g>
    );
};

interface PerformanceDataPoint {
  model: string;
  avgCompletionTimeSeconds: number;
}

interface RequestTimeChartProps {
  performanceData?: PerformanceDataPoint[];
  isLoading?: boolean;
}

// --- (Main) Refactored RequestTimeChart Component ---

const RequestTimeChart: React.FC<RequestTimeChartProps> = ({ performanceData, isLoading }) => {
    const [activeBarName, setActiveBarName] = useState<string | null>(null);

    const chartData = useMemo(() => {
        if (!performanceData) return [];
        return performanceData.map(item => ({
            name: item.model,
            time: item.avgCompletionTimeSeconds
        }));
    }, [performanceData]);

    const modelInfo = useMemo(() => {
      const info: { [key: string]: { name: string; color: string } } = {};
      chartData.forEach((item, index) => {
        const color = index < PREDEFINED_PALETTE.length
          ? PREDEFINED_PALETTE[index]
          : stringToColor(item.name);
        info[item.name] = { name: item.name, color };
      });
      return info;
    }, [chartData]);

    const legendItems = useMemo(() => {
        return Object.values(modelInfo);
    }, [modelInfo]);

    return (
        <Card elevation={0} sx={{ borderRadius: '16px', height: '100%', fontFamily: 'Inter, sans-serif' }}>
            <CardContent sx={{ p: { xs: 2, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h6" component="h3" sx={{ fontWeight: '600', fontSize: '16px' }}>
                        Average Request Completion Time
                    </Typography>
                    <Stack
                      direction="row"
                      spacing={2.5}
                      alignItems="center"
                      sx={{
                        maxWidth: '100%',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        flexWrap: 'nowrap',
                        pb: 1, // Padding for scrollbar
                        '::-webkit-scrollbar': { height: '4px' },
                        '::-webkit-scrollbar-thumb': { backgroundColor: '#d1d5db', borderRadius: '2px' },
                      }}
                    >
                        {legendItems.map((item) => (
                            <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                <FiberManualRecordIcon sx={{ color: item.color, fontSize: '10px', mr: 0.75 }} />
                                <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                    {item.name}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                </Box>

                <Box sx={{ flexGrow: 1, width: '100%' }}>
                  {isLoading ? (
                    <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }}/>
                  ) : (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={chartData}
                            margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                            barGap={10}
                        >
                            <CartesianGrid strokeDasharray="4 4" stroke="#EEE" horizontal={true} vertical={false} />
                            {/* MODIFIED: This line now hides the X-axis completely */}
                            <XAxis dataKey="name" hide={true} />
                            <YAxis
                                axisLine={false}
                                tickLine={false}
                                domain={[0, 'auto']}
                                tickCount={5}
                                tick={<CustomYAxisTick />}
                                width={40}
                            />
                            <Tooltip
                                cursor={false}
                                content={<CustomTooltip activeBarName={activeBarName} modelInfo={modelInfo} />}
                                isAnimationActive={false}
                            />
                            <Bar 
                                barSize={16}
                                radius={[10, 10, 0, 0]}
                                dataKey="time"
                            >
                                {chartData.map((entry, index) => (
                                    <Cell 
                                        key={`cell-${index}`} 
                                        fill={modelInfo[entry.name]?.color || '#ccc'}
                                        onMouseEnter={() => setActiveBarName(entry.name)}
                                        onMouseLeave={() => setActiveBarName(null)}
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                  )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default RequestTimeChart;